import React, { Component } from "react";
import { connect } from "react-redux";
import TopDomainsTableModal from "../../components/TrackedKeywords/TopDomainsTableModal";
import { fetchTopDomains } from "../../store/tracked_keywords/operations";
import { isFetchingTopDomains, getTopDomains } from "../../store/tracked_keywords/selectors";

class TopDomains extends Component {
  render() {
    return (
      <TopDomainsTableModal
        keyword={this.props.keyword}
        seoDb={this.props.seoDb}
        isLoading={this.props.isLoading}
        topDomains={this.props.topDomains}
        modalTitle={this.props.modalTitle}
        openLabel={this.props.openLabel}
        fetchTopDomains={this.props.fetchTopDomains}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyword, seoDb } = ownProps;
  const h_key = `${keyword}:${seoDb}`;

  return {
    isLoading: isFetchingTopDomains(state, h_key),
    topDomains: getTopDomains(state, h_key)
  };
};

export default connect(
  mapStateToProps,
  { fetchTopDomains }
)(TopDomains);
